import { useCallback } from 'react';

import { getStaticAssetUrl } from '@change-corgi/core/assets';
import { isPreviewDemoEnvironment } from '@change-corgi/core/environment';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

export function useGetStaticAssetUrl(): (pathname: string) => string {
	const { environment } = useUtilityContext();
	const apiSubEnv = environment.getApiSubEnvironment();
	// Preview demo envs are deployed via ArgoCD and don't have a corresponding static assets domain,
	// so we fall back to the target demo env (e.g. cyan) for asset URLs.
	const env = isPreviewDemoEnvironment(apiSubEnv)
		? (environment.getApiDemoEnvironmentTarget() ?? apiSubEnv)
		: apiSubEnv;
	return useCallback((pathname: string) => getStaticAssetUrl(env, pathname), [env]);
}

export function useStaticAssetUrl(pathname: string): string {
	return useGetStaticAssetUrl()(pathname);
}
